import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const StepperContainer = styled.div`
  display: inline-flex;
  align-items: center;
  height: 36px;
  border: 1px solid ${COLORS.strokeStatic};
  border-radius: 4px;
  overflow: hidden;
`

export const StepperButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background-color: ${COLORS.bgWhite};
  color: ${COLORS.textSecondary};
  cursor: pointer;

  /* svg fill="currentColor" → 한도 도달 시 회색(#ACAEB4) */
  &[aria-disabled='true'] {
    color: ${COLORS.textPlaceholder};
  }
`

export const StepperValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 8px 6px;
  border-left: 1px solid ${COLORS.strokeStatic};
  border-right: 1px solid ${COLORS.strokeStatic};
  color: ${COLORS.textPrimary};
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.27px;
  text-align: center;
`
